<template>
  <chain-viewer :list-of-certificates="certListSort" />
</template>

<script>
import ChainViewer from '@/components/ChainViewer.vue'
import * as asn1js from 'asn1js'
import {
  toBase64,
  arrayBufferToString
} from 'pvutils'
import * as x509 from '@peculiar/x509'
const pkijs = require('pkijs')
export default {
  created () {
    this.listOfCertificates()
  },
  components: { ChainViewer },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data () {
    return { certListSort: [] }
  },
  methods: {
    async listOfCertificates () {
      const buffer = await this.$store.dispatch('export/exportObj', { obj: this.name })
      const asn1obj = asn1js.fromBER(buffer)
      const contentInfo = new pkijs.ContentInfo({ schema: asn1obj.result })
      const signedData = new pkijs.SignedData({ schema: contentInfo.content })

      const certList = []
      signedData.certificates.forEach(cert => {
        const certBase64 = toBase64(arrayBufferToString(cert.toSchema(true).toBER(false)))
        certList.push(new x509.X509Certificate(certBase64))
      })

      this.certListSort = certList
    }
  }

}
</script>

<style lang="scss" scoped>
.v-card {
  background-color: transparent;
}
</style>
